<script>
import { Bar } from 'vue-chartjs'
import { ChartOptions } from './chartOptions'
import CustomChartMethods from './customChartMethods'
import { useAccessibility } from '../../composables/useAccessibility'
export default {
  name: 'BarChart',
  setup() {
    const { applyChartAccessibility } = useAccessibility()
    return { applyChartAccessibility }
  },
  extends: Bar,
  props: ['chartData', 'colorsList'],
  data() {
    return {
      options: ChartOptions,
    }
  },
  mounted() {
    this.plotChart()
  },
  methods: {
    destroyChart() {
      if (this.$data._chart) {
        this.$data._chart.destroy()
      }
    },
    plotChart() {
      this.destroyChart()
      const chartData = this.chartData ? new CustomChartMethods().getChartData('BarChart', this.colorsList, this.chartData) : null
      this.renderChart(chartData, this.options)
      this.applyChartAccessibility()
    },
  },
  destroyed() {
    this.destroyChart()
  },
  watch: {
    chartData(newValue, oldValue) {
      this.plotChart()
    },
  },
}
</script>
